import { z } from 'zod'
import { EventAvailabilityMenu } from '~/services/api/contracts/EventAvailabilityMenu'
import type { EventAvailabilityMenus } from '~/types/EventAvailabilityMenus'

const EventAvailabilityMenuList = z.array(EventAvailabilityMenu)

/** The menus' availability fields; one menu that does not match the contract makes the whole list invalid. */
export const parseEventAvailabilityMenus = (menus: readonly unknown[]): EventAvailabilityMenus => {
  const parsed = EventAvailabilityMenuList.safeParse(menus)
  return parsed.success ? { isValid: true, menus: parsed.data } : { isValid: false }
}
